import React from 'react'
import styled, { css } from 'styled-components'
import { Progress } from '@base-ui-components/react/progress'

interface SimpleProgressBarProps {
    label?: string
    value: number
    type?: 'round' | 'square'
}

export function SimpleProgressBar({
    label,
    value,
    type = 'round',
    ...props
}: SimpleProgressBarProps) {
    const valueToUse = value
    return (
        <Root value={valueToUse} {...props}>
            {label && <Label>{label}</Label>}
            <Track type={type}>
                <Indicator value={valueToUse} type={type} />
            </Track>
        </Root>
    )
}

const Root = styled(Progress.Root)<{ type?: 'round' | 'square' }>`
    width: 100%;
    height: 10px;
    border-radius: ${({ type }) => (type === 'square' ? '0px' : '0.625rem')};
`

const Track = styled(Progress.Track)<{ type?: 'round' | 'square' }>`
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) =>
        theme?.colors?.background?.bg1 || '#f0f0f0'};
    border-radius: ${({ type }) => (type === 'square' ? '0px' : '0.625rem')};
`

const Indicator = styled(Progress.Indicator)<{
    type?: 'round' | 'square'
    value: number
}>`
    height: 100%;
    background: linear-gradient(
        to right,
        ${({ theme }) => theme?.colors?.info || '#007bff'},
        ${({ theme }) => theme?.colors?.info || '#0056b3'}
    );
    border-radius: ${({ type }) => (type === 'square' ? '0' : '0.625rem')};

    ${({ type }) =>
        type === 'square' &&
        css`
            border-radius: 0px 0.625rem 0.625rem 0px;
        `}
    ${({ type, value }) =>
        type === 'square' &&
        value === 100 &&
        css`
            border-radius: 0;
        `}
`

const Label = styled(Progress.Label)`
    font-size: ${({ theme }) => theme?.typography?.fontSize?.sm || '0.875rem'};
    font-weight: ${({ theme }) => theme?.typography?.fontWeight?.medium || 500};
    color: ${({ theme }) => theme?.colors?.text?.secondary || '#6b7280'};
    margin-bottom: ${({ theme }) => theme?.spacing?.[2] || '0.5rem'};
`
